import { splitObject } from '@woorcs/utils'

import { systemPropNames, SystemProps } from './props'

export const splitSystemProps = <P extends SystemProps>(props: P) =>
  splitObject(props, systemPropNames)
